import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Row, Container } from 'reactstrap';

import ProductCardCarousel from 'Components/Carousel/ProductCardCarousel/ProductCardCarousel';
import PriceContainer from 'Components/Utility/Price/PriceContainer';
import HitCard from 'Components/Cards/HitCard';
import ProductRecommendations from 'Components/ProductRecommendations/ProductRecommendations';
import { fetchEbookBundleCarousel, fetchSoftwareBundleSection } from 'Redux/ducks/algolia-calls';

const BundleEndedRecommendations = ({ franchises, displayType }) => {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const fetchEbookHits = async () => {
      const ebookHits = await fetchEbookBundleCarousel();
      return setHits(ebookHits);
    };

    const fetchSoftwareHits = async () => {
      const results = await fetchSoftwareBundleSection();
      const softwareHits = get(results, 'hits', []);
      setHits(softwareHits);
    };

    if (['book-bundle', 'elearning-bundle', 'elearning'].includes(displayType)) {
      fetchEbookHits();
    }

    if (displayType === 'software') {
      fetchSoftwareHits();
    }
  }, [displayType]);

  const sliderSettings = {
    sm: {
      sliderWidth: 488,
    },
    md: {
      sliderWidth: 668,
    },
    lg: {
      sliderWidth: 876,
    },
    xl: {
      sliderWidth: 1056,
    },
    xxl: {
      sliderWidth: 1256,
    },
  };

  if (!isEmpty(hits)) {
    return (
      <Container>
        <div className={`recommendation-container ${hits.length >= 5 ? 'recommendation-container-carousel-padding' : ''}`}>
          {hits.length < 5 &&
            <Row className="recommendation-container">
              {hits && hits.slice(0, 4).map(hit =>
                <HitCard
                  key={hit.objectID}
                  hit={hit}
                >
                  <PriceContainer
                    discountPercent={hit.discount_percent}
                    price={hit.price}
                    tiered={hit.tiered}
                    slug={hit.slug}
                    hideDiscount={hit.hide_discount}
                    payWhatYouWant={hit.pay_what_you_want}
                  />
                </HitCard>,
              )}
            </Row>
          }

          {hits.length >= 5 &&
            <ProductCardCarousel
              resetCarousel
              hitData={hits}
              slidesToShow={4}
              sliderSettings={sliderSettings}
            />
          }
        </div>
      </Container>
    );
  }

  return (
    <ProductRecommendations
      forceBundle
      hideTitle
      franchises={franchises}
      sliderSettings={sliderSettings}
    />
  );
};

BundleEndedRecommendations.propTypes = {
  franchises: PropTypes.arrayOf(PropTypes.string),
  displayType: PropTypes.string,
};

BundleEndedRecommendations.defaultProps = {
  franchises: [],
  displayType: '',
};


export default BundleEndedRecommendations;
